<div class="main-container">

  <div class="title">
    <span class="title-text">View As Role</span>
    <p class="small-title">Preview the views and permissions a role grants, or view the app as that role.</p>
  </div>

  <div class="picker">
    <div class="field">
      <span class="field-label">Role</span>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="roleId" (selectionChange)="onRoleChange()">
          @for(r of roles; track r.roleId){ <mat-option [value]="r.roleId">{{ r.roleName }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    @if(needsEstablishment){
    <div class="field">
      <span class="field-label">Establishment</span>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select panelClass="ac-select-panel" [disableOptionCentering]="true" [formControl]="establishmentId" placeholder="Select establishment">
          @for(e of establishments; track e.establishmentId){ <mat-option [value]="e.establishmentId">{{ e.name }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    }
    @if(hasSelected && !isLoading && role){
    <div class="field view-as-action">
      <button type="button" class="ac-primary-btn" [disabled]="!tree.length" (click)="enterViewAs()">View as this role</button>
      <span class="hint">The menu, buttons and API checks follow this role until you exit (banner in the sidebar).</span>
    </div>
    }
  </div>

  @if(hasSelected && !isLoading){
  <div class="tree-container">
    @if(tree.length){
    <ul class="tree">
      @for(node of tree; track node.key){
        <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: node }"></ng-container>
      }
    </ul>
    } @else {
    <p class="empty-row">This role grants no views.</p>
    }
  </div>
  }

</div>

<ng-template #nodeTpl let-node>
  <li class="node">
    <div class="node-row">
      <span class="node-label">{{ node.labelName || node.viewName }}</span>
      @if(node.permission?.length){
      <span class="node-perms">{{ node.permission.join(', ') }}</span>
      }
    </div>
    @if(node.subview?.length){
    <ul class="tree">
      @for(child of node.subview; track child.key){
        <ng-container *ngTemplateOutlet="nodeTpl; context: { $implicit: child }"></ng-container>
      }
    </ul>
    }
  </li>
</ng-template>

<app-loader [isLoading]="isLoading"></app-loader>
